<template>
  <b-nav-item-dropdown right no-caret>
    <template slot="button-content">
      <span @click="updateFlag = true">
        <i class="fa fa-bell"></i>
        <span class="label label-warning">{{ getLatestNotice.length }}</span>
      </span>
    </template>
    <template v-for="noticeKey in sliceLatestNotices">
      <b-dropdown-item  :key="noticeKey.id" v-if="noticeKey.notice && noticeKey.notice.type" @click="getDetail(noticeKey.notice)">
        <notice-item :text="setText(noticeKey.notice)" :type="setType(Object.keys(noticeKey.notice.type)[0])" :img="setImg(Object.keys(noticeKey.notice.type)[0])" :time="preparedTime(noticeKey.notice.createdAt)"/>
      </b-dropdown-item>
    </template>
    <b-dropdown-item :to="'../notice/list'">
      <div class="flex-box no-margin">
        <div class="notice">{{ $t('indicateAllNotice') }}</div>
      </div>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>

import { i18n, liteMode } from '@/main.js'
import { mapGetters, mapActions } from 'vuex'
import CommonJs from '@/js/common'
import moment from 'moment'
import NoticeItem from '@/components/Notice/NoticeItem'

export default {
  name: 'header-dropdown',
  mixins: [CommonJs],
  components: {
    NoticeItem
  },
  data: () => {
    return {
      time: '',
      count: 0,
      updateFlag: false,
      latestNotices: []
      // open: false
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUserInfo',
      'getCurrentUser'
    ]),
    ...mapGetters({
      getCurrentNotices: 'notices/getCurrentNotices',
      getLatestNoticesByUserId: 'notices/getLatestNoticesByUserId'
    }),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    ...mapGetters('groups/', [
      'getGroupById'
    ]),
    getLatestNotice () {
      const getLatestNotices = this.getLatestNoticesByUserId
      let latestNotice = []
      if (liteMode) {
        for (const noticeKey in getLatestNotices) {
          if (!getLatestNotices[noticeKey].notice.noticeKey.includes('Objective') && !getLatestNotices[noticeKey].notice.noticeKey.includes('KeyResult')) {
            latestNotice.push(getLatestNotices[noticeKey])
          }
        }
      } else {
        latestNotice = getLatestNotices
      }

      if (this.updateFlag) {
        this.updateFlag = false
        this.latestNotices = latestNotice
        this.updateLastNotice()
      }
      for (const latest of latestNotice) {
        // console.log(latest)
        if (latest.notice.type.system) {
          this.excuteSystemMessage(latest.notice)
        }
      }
      return latestNotice
    },
    sliceLatestNotices () {
      return this.latestNotices.slice(0, this.latestNotices.length > 10 ? 10 : this.latestNotices.length)
    },
    checkLanguage () {
      return i18n.locale
    },
    noticeCreatedObjective () { return this.$t('noticeCreatedObjective') },
    noticeCreatedKeyResult () { return this.$t('noticeCreatedKeyResult') },
    noticeCreated1on1 () { return this.$t('noticeCreated1on1') },
    noticeCreatedRTFB () { return this.$t('noticeCreatedRTFB') },
    noticeUpdatedObjective () { return this.$t('noticeUpdatedObjective') },
    noticeUpdatedKeyResult () { return this.$t('noticeUpdatedKeyResult') },
    noticeUpdated1on1 () { return this.$t('noticeUpdated1on1') },
    noticeUpdatedRTFB () { return this.$t('noticeUpdatedRTFB') },
    noticeDeletedObjective () { return this.$t('noticeDeletedObjective') },
    noticeDeletedKeyResult () { return this.$t('noticeDeletedKeyResult') },
    noticeDeleted1on1 () { return this.$t('noticeDeleted1on1') },
    noticeDeletedRTFB () { return this.$t('noticeDeletedRTFB') },
    noticeCommentedOnObjective () { return this.$t('noticeCommentedOnObjective') },
    noticeCommentedOnKeyResult () { return this.$t('noticeCommentedOnKeyResult') },
    noticeCommentedOn1on1 () { return this.$t('noticeCommentedOn1on1') },
    noticeCommentedOnRTFB () { return this.$t('noticeCommentedOnRTFB') },
    noticeCompletedObjective () { return this.$t('noticeCompletedObjective') },
    noticeCompletedKeyResult () { return this.$t('noticeCompletedKeyResult') },
    noticeMemberOfGroup () { return this.$t('noticeMemberOfGroup') },
    noticeRequested1on1 () { return this.$t('noticeRequested1on1') },
    noticeLiked () { return this.$t('noticeLiked') },
    noticeMessaged () { return this.$t('noticeMessaged') },
    noticeDateFormat () { return this.$t('noticeDateFormat') },
    noticeGroupDeleted () { return this.$t('noticeGroupDeleted') },
    noticeConfigUser () { return this.$t('noticeConfigUser') },
    noticeConfigGroup () { return this.$t('noticeConfigGroup') },
    noticeUnavailable () { return this.$t('noticeUnavailable') },
    noticeAvailable () { return this.$t('noticeAvailable') },
    noticeRemovedGroup () { return this.$t('noticeRemovedGroup') },
    noticeNewVersionReleased () { return this.$t('noticeNewVersionReleased') }
  },
  methods: {
    ...mapActions({
      setLastNotice: 'notices/SET_LAST_NOTICE'
    }),
    excuteSystemMessage: function (item) {
      const system = item.type.system
      const date = new Date()
      const latestNotice = date / 1000
      this.setLastNotice(latestNotice)
      console.log('system', system)
      switch (system) {
        case 'forceSignOut':
          this.$swal({
            title: item.contentText,
            type: 'warning',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 5000
          })
          this.$firebase.auth().signOut().then(
            this.$router.replace({ name: 'Login' })
          )
          break
        default:
          break
      }
    },
    getDetail: function (value) {
      if (value.type.group) {
        if (value.noticeKey === 'noticeRemovedGroup') { return }
        this.$router.push({ name: 'GroupList', params: { item: value.type } })
      } else if (value.type['1on1requests']) {
        this.$router.push({ name: 'OneRequestRece', params: { item: value.type } })
      } else if (value.type['comments']) {
        this.$router.push({
          name: 'User',
          params: {
            userId: value.noticeOpt.targetOwner || '',
            item: {
              [value.noticeOpt.targetType]: value.noticeOpt.targetId
            },
            noticeKey: value.noticeKey,
            noticeType: value.type ? Object.keys(value.type)[0] : null
          }
        })
      } else {
        this.$router.push({ name: 'User', params: { userId: value.userId, item: value.type, noticeKey: value.noticeKey } })
      }
    },
    updateLastNotice: function () {
      if (this.getLatestNotice[0]) {
        let latestNotice = this.getLatestNotice[0].notice.createdAt / 1000
        this.setLastNotice(latestNotice)
      }
    },
    setImg (type) {
      switch (type) {
        case 'group':
          return 'static/img/notice/group.png'
        case 'keyresults':
        case 'objectives':
          return 'static/img/notice/okr.png'
        case 'system':
          return 'static/img/notice/okr.png'
        case 'comments':
          return 'static/img/assets/comment.png'
        case 'rtfbs':
          return 'static/img/notice/rtfb.png'
        default:
          return 'static/img/notice/1on1.png'
      }
    },
    setType (type) {
      switch (type) {
        case 'group':
          return 'グループ'
        case 'keyresults':
        case 'objectives':
          return 'OKR'
        case 'system':
          return 'システム'
        case 'comments':
          return 'コメント'
        case 'rtfbs':
          return 'FB Request'
        default:
          return '1on1'
      }
    },
    setText (value) {
      let contentText
      if (value.noticeOpt) {
        let noticeUserName = this.getUserInfoById(value.noticeOpt.userId || value.userId).userName || ''
        if (value.noticeOpt.userName && value.noticeOpt.ymd) {
          let date
          let dateFormat = []
          dateFormat = value.noticeOpt.ymd.split('-')
          if (this.checkLanguage === 'en') dateFormat.reverse()
          date = dateFormat.join('/')
          contentText = this[value.noticeKey].replace('{$user}', noticeUserName).replace('{$date}', date)
        } else if (value.noticeOpt.userName && value.noticeOpt.commentKey) {
          contentText = this[value.noticeKey].replace('{$user}', noticeUserName)
        } else if (value.noticeOpt.userName && !value.noticeOpt.ymd && !value.noticeOpt.userId) {
          contentText = this[value.noticeKey].replace('{$user}', noticeUserName)
        } else if (value.noticeOpt.userName && !value.noticeOpt.ymd) {
          contentText = this[value.noticeKey].replace('{$user}', noticeUserName)
        } else if (value.noticeOpt.groupName) {
          if (this.getGroupById(Object.values(value.type))) {
            contentText = this[value.noticeKey].replace('{$group}', this.getGroupById(Object.values(value.type)).groupName)
          } else {
            contentText = this[value.noticeKey].replace('{$group}', value.noticeOpt.groupName)
          }
        } else if (value.noticeOpt.latestVersion) {
          contentText = this[value.noticeKey].replace('{$version}', value.noticeOpt.latestVersion)
        }
      } else {
        contentText = value.contentText
      }
      return contentText
    },
    preparedTime (time) {
      if (this.checkLanguage === 'zh_tr') {
        moment.locale('zh_tw')
      } else {
        moment.locale(this.checkLanguage)
      }
      let timestamp = moment(time).fromNow()
      return timestamp
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column-reverse;
  }
  .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
  }
  .ibox-child:last-of-type {
    border-top: 0px;
  }
  .no-margin{
    margin: 0;
  }
  .app-header.navbar .dropdown-menu {
    width: 40vh;
    max-width: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdown.vue